<template>
  <div style="background-color:black; height:100vh;">
    <v-container fluid fill-height>
      <!-- Back Button -->
      <v-btn icon class="back-button" @click="confirmBackNavigation">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <!-- Page Header -->
      <v-row class="pa-7" justify="center">
        <h2 class="red--text">ADD SERIAL NUMBER</h2>
      </v-row>

      <!-- Form Card -->
      <v-row class="fill-height pa-0 ma-0" justify="center" align="start">
        <v-col cols="12" class="pa-0">
          <v-card elevation="0" class="add-serial-card">
            <v-card-text>
              <v-overlay :value="loading">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>

              <v-row>
                <h2 class="red--text mx-12" style="margin-bottom: 30px;">
                  SERIAL NUMBER DETAILS
                </h2>
                <v-spacer></v-spacer>
              </v-row>

              <v-form ref="form" v-model="valid" lazy-validation>
                <!-- Row 1: primaryKey, linkKey, date, customer, docNumber -->
                <v-row>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="primaryKey"
                      label="Certificate Number"
                      dense
                      outlined
                      readonly
                      prepend-inner-icon="mdi-key"
                      class="montserrat-input"
                      :rules="[rules.required, rules.qcPrefix]"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="linkKey"
                      label="Serial Number"
                      dense
                      outlined
                      prepend-inner-icon="mdi-link"
                      class="montserrat-input"
                      :rules="[rules.required, rules.qcPrefix]"
                      @input="ensureQCPrefix('linkKey')"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-menu
                      ref="dateMenu"
                      v-model="dateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="date"
                          label="Date"
                          readonly
                          dense
                          outlined
                          prepend-inner-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          :rules="[rules.required]"
                        />
                      </template>
                      <v-date-picker
                        v-model="date"
                        @input="dateMenu = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="customer"
                      :items="customerOptions"
                      item-text="companyName"
                      item-value="companyName"
                      label="Customer"
                      dense
                      outlined
                      prepend-inner-icon="mdi-account-group"
                      :rules="[rules.required]"
                      :loading="customerLoading"
                      :disabled="!customerOptions.length"
                      :hint="customerOptions.length ? '' : 'No customers available'"
                      persistent-hint
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="docNumber"
                      label="SO/INV Number"
                      dense
                      outlined
                      prepend-inner-icon="mdi-file-document"
                      class="montserrat-input"
                      :rules="[rules.required]"
                    />
                  </v-col>
                </v-row>

                <!-- Row 2: code, elastomers, ibs, ibr, obs, obr -->
                <v-row>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="code"
                      label="Type/Code"
                      dense
                      outlined
                      prepend-inner-icon="mdi-cog"
                      class="montserrat-input"
                      :rules="[rules.required]"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="elastomers"
                      label="Elastomers"
                      dense
                      outlined
                      prepend-inner-icon="mdi-cog"
                      class="montserrat-input"
                      :rules="[rules.required]"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="ibs"
                      label="IBS Face Material"
                      dense
                      outlined
                      prepend-inner-icon="mdi-cog-outline"
                      class="montserrat-input"
                      :rules="[rules.required]"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="ibr"
                      label="IBR Face Material"
                      dense
                      outlined
                      prepend-inner-icon="mdi-cog-outline"
                      class="montserrat-input"
                      :rules="[rules.required]"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="obs"
                      label="OBS Face Material"
                      dense
                      outlined
                      prepend-inner-icon="mdi-cog-outline"
                      class="montserrat-input"
                 
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="obr"
                      label="OBR Face Material"
                      dense
                      outlined
                      prepend-inner-icon="mdi-cog-outline"
                      class="montserrat-input"
            
                    />
                  </v-col>
                </v-row>

                <!-- Row 3: Shaft Size -->
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="shaftSize"
                      label="Shaft Size"
                      dense
                      outlined
                      prepend-inner-icon="mdi-ruler"
                      class="montserrat-input"
                      :rules="[rules.required]"
                    />
                  </v-col>
                </v-row>

                <!-- Row 4: notes -->
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="notes"
                      label="Notes"
                      auto-grow
                      rows="2"
                      dense
                      outlined
                      prepend-inner-icon="mdi-note"
                      class="montserrat-input"
                    />
                  </v-col>
                </v-row>

                <!-- Save Button -->
                <v-row justify="center" class="mt-8">
                  <v-btn
                    dark
                    large
                    width="300px"
                    @click="confirmSubmit"
                    class="montserrat-button pa-0"
                  >
                    <v-icon left>mdi-content-save</v-icon>Save
                  </v-btn>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Confirmation Dialog -->
    <v-dialog v-model="confirmationDialog.visible" max-width="400">
      <v-card class="confirmation-dialog-card">
        <v-card-title class="headline pa-4">
          {{ confirmationDialog.title }}
        </v-card-title>
        <v-card-text>{{ confirmationDialog.message }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="confirmationDialog.confirm">
            <v-icon left>mdi-check</v-icon>Yes
          </v-btn>
          <v-btn color="grey" text @click="confirmationDialog.visible = false">
            <v-icon left>mdi-close</v-icon>No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Success Snackbar -->
    <v-snackbar v-model="successSnackbar" color="success" timeout="3000">
      {{ successMessage }}
      <v-btn color="white" text @click="successSnackbar = false">Close</v-btn>
    </v-snackbar>

    <!-- Error Snackbar -->
    <v-snackbar v-model="errorSnackbar" color="error" timeout="3000">
      {{ errorMessage }}
      <v-btn color="white" text @click="errorSnackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { getFirestore, collection, getDocs, addDoc } from "firebase/firestore";
import { firebaseApp, auth } from "@/firebaseConfig";

const db = getFirestore(firebaseApp);

export default {
  name: "AddSerialNumber",
  data() {
    return {
      loading: false,
      customerLoading: false,
      valid: false,
      primaryKey: "",
      linkKey: "NSS",
      date: "",
      dateMenu: false,
      customer: "",
      docNumber: "",
      code: "",
      elastomers: "",
      ibs: "",
      ibr: "",
      obs: "",
      obr: "",
      shaftSize: "",
      notes: "",
      customerOptions: [],
      confirmationDialog: { visible: false, title: "", message: "", confirm: () => {} },
      successSnackbar: false,
      successMessage: "",
      errorSnackbar: false,
      errorMessage: "",
      rules: { 
        required: v => !!v || "Required.",
        qcPrefix: v => (v && v.startsWith("NSS")) || "Must start with NSS"
      },
    };
  },
  async created() {
    this.loading = true;
    try {
      const user = auth.currentUser;
      if (user) console.log("Logged-in user:", user.email);

      await Promise.all([
        this.fetchCustomerOptions(),
        this.getPrimaryKey(),
      ]);
    } catch (e) {
      console.error("Initialization error:", e);
      this.errorMessage = "Failed to initialize form.";
      this.errorSnackbar = true;
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async fetchCustomerOptions() {
      this.customerLoading = true;
      try {
        const customersSnapshot = await getDocs(collection(db, "customers"));
        this.customerOptions = customersSnapshot.docs
          .map(doc => ({
            docId: doc.id,
            companyName: doc.data()["Company Name"] || "",
            contactPerson: doc.data()["Contact Person"] || "",
            customerAccount: doc.data()["Customer Account"] || "",
          }))
          .filter(c => c.companyName)
          .sort((a, b) => a.companyName.localeCompare(b.companyName));

        if (!this.customerOptions.length) {
          this.errorMessage = "No customers available. Please add some.";
          this.errorSnackbar = true;
        } else {
          localStorage.setItem("customers", JSON.stringify(this.customerOptions));
        }
      } catch (e) {
        console.error("Error fetching customers:", e);
        this.errorMessage = "Failed to load customers.";
        this.errorSnackbar = true;
      } finally {
        this.customerLoading = false;
      }
    },

    async getPrimaryKey() {
      try {
        const defaultStart = 11109;
        const snap = await getDocs(collection(db, "SerialNumber"));
        const suffixes = snap.docs
          .map(d => {
            const key = d.data().primaryKey;
            const num = key && key.startsWith("NSS") ? parseInt(key.slice(3), 10) : NaN;
            return isNaN(num) ? null : num;
          })
          .filter(n => n !== null);

        const maxSuffix = suffixes.length ? Math.max(...suffixes) : defaultStart - 1;
        this.primaryKey = `NSS${maxSuffix + 1}`;
      } catch (e) {
        console.error("Error fetching primary key:", e);
        this.errorMessage = "Failed to generate primary key.";
        this.errorSnackbar = true;
      }
    },

    ensureQCPrefix(field) {
      if (field === "linkKey" && this[field] && !this[field].startsWith("NSS")) {
        this[field] = "NSS" + this[field];
      }
    },

    confirmSubmit() {
      if (!this.$refs.form.validate()) {
        this.errorMessage = "Please fill all required fields correctly.";
        this.errorSnackbar = true;
        return;
      }
      this.confirmationDialog = {
        visible: true,
        title: "Confirm Save",
        message: "Are you sure you want to save this serial number?",
        confirm: this.submitForm,
      };
    },

    async submitForm() {
      this.loading = true;
      try {
        const data = {
          primaryKey: this.primaryKey,
          linkKey: this.linkKey,
          date: this.date,
          customer: this.customer,
          docNumber: this.docNumber,
          code: this.code,
          elastomers: this.elastomers,
          ibs: this.ibs,
          ibr: this.ibr,
          obs: this.obs || "",
          obr: this.obr || "",
          shaftSize: this.shaftSize,
          notes: this.notes || "",
        };
        await addDoc(collection(db, "SerialNumber"), data);

        this.successMessage = "Serial number added successfully!";
        this.successSnackbar = true;

        // Reset and navigate back
        this.$refs.form.resetValidation();
        this.$refs.form.reset();
        this.linkKey = "NSS";
        this.shaftSize = "";
        this.$router.push({ name: "AllSerialNumber" });
      } catch (e) {
        console.error("Error saving serial number:", e);
        this.errorMessage = "Failed to save serial number.";
        this.errorSnackbar = true;
      } finally {
        this.loading = false;
        this.confirmationDialog.visible = false;
      }
    },

    confirmBackNavigation() {
      this.confirmationDialog = {
        visible: true,
        title: "Confirm Navigation",
        message: "Unsaved changes will be lost. Go back?",
        confirm: this.goBack,
      };
    },

    goBack() {
      this.confirmationDialog.visible = false;
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");

.add-serial-card {
  box-shadow: 10px 10px 20px #1b1c1e, -10px -10px 20px #c4242b;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 20px;
  width: 100%;
  padding: 20px;
  transition: all 0.3s ease-in-out;
}

.montserrat-input,
.montserrat-button {
  font-family: "Montserrat", sans-serif;
}

.pa-0 {
  padding: 0 !important;
}

.back-button {
  color: white;
  border-radius: 50%;
  position: absolute;
  top: 16px;
  left: 16px;
  transition: transform 0.3s ease-in-out;
}

.back-button:hover {
  transform: scale(1.1);
}

.confirmation-dialog-card {
  border-radius: 8px;
  background-color: #ffffff;
}

.confirmation-dialog-card .headline {
  background-color: #c4242b;
  color: white;
  font-family: "Montserrat", sans-serif;
}

.v-text-field--outlined >>> fieldset,
.v-select--outlined >>> fieldset,
.v-autocomplete--outlined >>> fieldset {
  border-color: #555;
}

.v-text-field--outlined:hover >>> fieldset,
.v-select--outlined:hover >>> fieldset,
.v-autocomplete--outlined:hover >>> fieldset {
  border-color: #c4242b;
}

.v-btn.primary {
  background-color: #c4242b !important;
  color: white !important;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.v-btn.primary:hover {
  background-color: #a31f24 !important;
  transform: translateY(-1px);
}

.montserrat-button {
  font-weight: 700;
  letter-spacing: 1px;
}
</style>
